/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteAppointmentNotificationConfigData$Params {

/**
 * id configuration type book
 */
  id: string;

/**
 * configuration keys
 */
  keys: Array<'BATCH_MANAGEMENT' | 'STOCK_MINUS_QUANTITY_BLOCKED' | 'TEMPERATURE' | 'HEART_BEAT' | 'BREATH_FREQUENCY' | 'BMI' | 'EXT_IS_APPOINTMENT_CONFIRMATION_REQUIRED' | 'EXT_MAX_NUM_ANIMALS' | 'EXT_MAX_NUM_DAYS' | 'EXT_MAX_MINUTES_BLOCKED' | 'EXT_PREFERRED_VET' | 'EXT_SHOULD_ADD_ANIMAL_TIME' | 'EXT_WELCOME_TEXT_DE' | 'EXT_WELCOME_TEXT_FR' | 'EXT_WELCOME_TEXT_IT' | 'EXT_WELCOME_TEXT_EN' | 'EXT_MAILCLOSING_TEXT_DE' | 'EXT_MAILCLOSING_TEXT_FR' | 'EXT_MAILCLOSING_TEXT_IT' | 'EXT_MAILCLOSING_TEXT_EN' | 'EXT_RESOURCE_RESTRICTION' | 'TAMV_SERVICE_BID' | 'DAYS_BEFORE_APPOINTMENT_NOTIFICATION' | 'HOUR_OF_APPOINTMENT_NOTIFICATION' | 'EXT_SHOW_AVAILABLE_VETS' | 'HAS_SALUTATION_APPOINTMENT_NOTIFICATION' | 'HAS_REASONS_APPOINTMENT_NOTIFICATION' | 'HAS_ANIMALS_APPOINTMENT_NOTIFICATION' | 'HAS_FREETEXT_APPOINTMENT_NOTIFICATION' | 'HAS_ADDRESS_APPOINTMENT_NOTIFICATION' | 'DE_FREETEXT_APPOINTMENT_NOTIFICATION' | 'FR_FREETEXT_APPOINTMENT_NOTIFICATION' | 'IT_FREETEXT_APPOINTMENT_NOTIFICATION' | 'HEX_ARGUS_BUR' | 'HEX_ARGUS_USERNAME' | 'HEX_ARGUS_PASSWORD' | 'HOUR_OF_SENDING_REMINDER' | 'DAYS_BEFORE_TREATMENT' | 'HAS_SALUTATION_REMINDER' | 'HAS_ANIMAL_REMINDER' | 'HAS_REASON_REMINDER' | 'HAS_TREATMENT_DATE_REMINDER' | 'HAS_DUE_DATE_REMINDER' | 'HAS_VETS_ADDRESS_REMINDER' | 'HAS_FREETEXT_REMINDER' | 'DE_FREETEXT_REMINDER' | 'FR_FREETEXT_REMINDER' | 'IT_FREETEXT_REMINDER' | 'CUSTOMER_TERMS_CONDITIONS_1' | 'CUSTOMER_TERMS_CONDITIONS_2' | 'CUSTOMER_TERMS_CONDITIONS_3' | 'EXT_APPOINTMENT_CANCELLATION_TIME'>;
}

export function deleteAppointmentNotificationConfigData(http: HttpClient, rootUrl: string, params: DeleteAppointmentNotificationConfigData$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteAppointmentNotificationConfigData.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('keys', params.keys, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteAppointmentNotificationConfigData.PATH = '/api/configuration/{id}/book/notification/{keys}';
